<template>
  <modal :center="false" :show="visible" modalClasses="modal-lg">
    <h3 class="text-center">
      {{ info.id ? "Cập nhật màu sắc" : "Thêm mới màu sắc" }}
    </h3>
    <block ref="bmdal">
      <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
        <form role="form" @submit.prevent="handleSubmit">
          <b-row>
            <b-col>
              <base-input
                label="Khóa"
                placeholder="Duy nhất (ví dụ: white)"
                v-model="info.key"
              ></base-input>
            </b-col>
            <b-col>
              <ValidationProvider
                name="Tên màu"
                rules="required"
                v-slot="{ errors }"
              >
                <base-input
                  label="Tên màu"
                  :error="errors[0]"
                  v-model="info.label"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
            <b-col>
              <ValidationProvider
                name="Màu hiển thị"
                rules="required"
                v-slot="{ errors }"
              >
                <base-input
                  type="color"
                  label="Màu hiển thị"
                  :error="errors[0]"
                  v-model="info.color"
                  :valid="errors.length == 0"
                ></base-input>
              </ValidationProvider>
            </b-col>
          </b-row>
        </form>
        <hr />
        <button type="button" @click="handleClose" class="btn btn-secondary">
          Đóng
        </button>
        <button type="button" @click="doSave(1)" class="btn btn-success">
          Lưu tiếp (Shift + F4)
        </button>
        <button type="submit" @click="doSave(0)" class="btn btn-dark">
          Lưu đóng (F4)
        </button>
      </ValidationObserver>
    </block>
    <event
      @doSave="doSave(0)"
      @doCancel="handleClose"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>
<script>
import { colorService } from "@/_services";
export default {
  data() {
    return {
      visible: false,
      info: {
        color: "#000"
      }
    };
  },
  methods: {
    doSave: function(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        if (self.info.id) {
          colorService
            .update(self.info.id, self.info)
            .then(res => {
              self.ownInfo.color = res.data.color;
              self.ownInfo.label = res.data.label;
              this.$alertify.success(res.message, {
                duration: 4000
              });
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              if (type == 0) {
                self.visible = false;
              }
              this.$refs.bmdal.unBlock();
            });
        } else {
          colorService
            .create(self.info)
            .then(() => {
              self.$alertify.success("Thêm thành công");
              self.info = {
                key: "",
                color: "",
                label: ""
              };
              self.$emit("submit:success");
              if (type == 0) {
                self.visible = false;
              }
            })
            .catch(err => {
              if (err.data) {
                err.data.forEach(element => {
                  let errObj = {};
                  errObj[element.context.key] = [element.message];
                  self.$refs.csInfo.setErrors(errObj);
                });
              }
            })
            .finally(() => {
              self.$refs.bmdal.unBlock();
            });
        }
      });
    },
    setData(info) {
      if (info) {
        this.ownInfo = info;
        this.info = Object.assign({}, info);
      } else {
        this.info = {};
      }
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss">
.wrap-drop-img {
  height: 200px !important;
}
</style>
